import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

import { SeatSetting } from '@core/objects/seat';

@Pipe({ name: 'seatsSortByName' })
export class SeatsSortByNamePipe implements PipeTransform {

  	transform(seats: SeatSetting[], order = ''): any[] {
    	if (!seats || order === '') { return seats; } // no array
		if (seats.length <= 1) { return seats; } // array with only one item
		return _.orderBy(seats, [seat => seat.user.name.toLowerCase()], [order]);
  	}
}